import React, { useContext } from 'react';
import { Route, Routes } from 'react-router-dom';

import { LoginContract } from './login/LoginContract';
import { LoginLayout } from './login/LoginLayout';
import { ProtectedLayout } from './screens/ProtectedLayout';
import CeoInfo from './screens/ceo/CeoInfo';
import Dashboard from './screens/dashboard/Dashboard';
// import Inventory from './screens/product/inventoryManage/Inventory';

import { Login } from './login/Login';
// import SaleCategory from './screens/sales/CategorySale';
// import SalesDaily from './screens/sales/Daily';
import Analysis from './screens/sales/Analysis';
import SalesPeriod from './screens/sales/Period';
// import SalesProduct from './screens/sales/ProductSale';

import { LoginForgetMain } from './login/loginForget/LoginForgetMain';
import { LoginUserJoinMain } from './login/loginUserJoin/LoginUserJoinMain';
import AdvertiseCategory from './screens/advertise/AdvertiseCategory';
import Inventory from './screens/product/inventory/Inventory';
import CategoryEdit from './screens/product/menu/CategoryEdit';
import CategoryIndex from './screens/product/menu/CategoryIndex';
import ProductEdit from './screens/product/product/ProductEdit';
import ProductIndex from './screens/product/product/ProductIndex';
import OptionEdit from './screens/product/productOption/OptionEdit';
import OptionIndex from './screens/product/productOption/OptionIndex';
import SetMenuEdit from './screens/product/setMenu/SetMenuEdit';
import SetMenuIndex from './screens/product/setMenu/SetMenuIndex';
import SalesCalendar from './screens/sales/SalesCalender';
import SalesMonthly from './screens/sales/SalesMonthly';
import StoreDelivery from './screens/store/StoreDelivery';
import StoreHoliday from './screens/store/StoreHoliday';
import StoreTestOrder from './screens/store/StoreTestOrder';
import SelfStoreTestOrder from './screens/store/SelfStoreTestOrder';
import StoreInfo from './screens/store/StoreInfo';
import StoreTime from './screens/store/StoreTime';
import CouponIndex from './screens/product/coupon/CouponIndex';
import CouponEdit from './screens/product/coupon/CouponEdit';
import SalesHotel from './screens/sales/SalesHotel';
import SalesStatus from './screens/sales/SalesStatus';
import NotificationIndex from './screens/notification/NotificationIndex';
import PosGuide from './screens/notification/PosGuide';
import SetItemIndex from './screens/product/setMenuItem/SetItemIndex';
import SetItemEdit from './screens/product/setMenuItem/SetItemEdit';
import AdvertiseUpload from './screens/advertise/AdvertiseUpload';
import SalesSettle from './screens/sales/SalesSettle';
import DeliveryManComplete from './screens/template/DeliveryManComplete';
import DeliveryManAccumulate from './screens/template/DeliveryManAccumulate';
import DeliveryManRegister from './screens/template/DeliveryManRegister';
import DeliveryManWithdraw from './screens/template/DeliveryManWithdraw';
import DeliveryManDelivery from './screens/template/DeliveryManDelivery';
import DeliveryConfirmList from './screens/template/DeliveryConfirmList';
import DeliveryManDeliveryShort from './screens/template/DeliveryManDeliveryShort';

import GuideLanding from './landing/GuideLanding';
import RestaurantVoucher from './voucher/RestaurantVoucher';
import OrderStatusMain from './orderStatus/OrderStatusMain';
import OrderCancel from './landing/OrderCancel';
import OrderStop from './landing/OrderStop';
import LoadingPage from './login/LoadingPage';
import SalesManager from './screens/SalesManager/SalesManager';
import TimeProductIndex from './screens/product/timeProduct/TimeProductIndex';
import TimeProductEdit from './screens/product/timeProduct/TimeProductEdit';
import AdverHotelIndex from './screens/advertise/AdverHotelIndex';
import { AuthContext } from './navigation/AuthProvider';

const App = () => {
  const { userInfo } = useContext(AuthContext);

  React.useEffect(() => {
    // const redirectToExternalBrowser = () => {
    //   console.log('redirect');
    //   const targetUrl = window.location.href;

    //   if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    //     window.location.href = 'x-web-search://?';
    //   } else {
    //     window.location.href = `intent://${targetUrl.replace(
    //       /https?:\/\//i,
    //       '',
    //     )}#Intent;scheme=http;package=com.android.chrome;end`;
    //   }
    // };

    // const userAgent = navigator.userAgent.toLowerCase();
    // if (/kakaotalk/i.test(userAgent)) {
    //   if (/iPhone|iPad|iPod/i.test(userAgent)) {
    //     setTimeout(() => {
    //       window.location.href = 'kakaoweb://closeBrowser';
    //     }, 100);
    //   } else {
    //     window.location.href = 'kakaotalk://inappbrowser/close';
    //   }
    //   window.location.href = `kakaotalk://web/openExternal?url=${encodeURIComponent(
    //     `${window.location.origin}${process.env.REACT_APP_BASE_URL}${
    //       userInfo ? '' : '/login?redirect='
    //     }${window.location.pathname.replace(process.env.REACT_APP_BASE_URL || '', '')}`,
    //   )}`;
    // }
    // } else if (/line/i.test(userAgent)) {
    //   const targetUrl = window.location.href;
    //   window.location.href = targetUrl.includes('?')
    //     ? `${targetUrl}&openExternalBrowser=1`
    //     : `${targetUrl}?openExternalBrowser=1`;
    // } else if (
    //   /inapp|naver|snapchat|wirtschaftswoche|thunderbird|instagram|everytimeapp|whatsApp|electron|wadiz|aliapp|zumapp|iphone.*whale|android.*whale|kakaostory|band|twitter|DaumApps|DaumDevice\/mobile|FB_IAB|FB4A|FBAN|FBIOS|FBSS|trill|SamsungBrowser\/[^1]/i.test(
    //     userAgent,
    //   )
    // ) {
    //   redirectToExternalBrowser();
    // }

    if (document) {
      let oDoc: any = document;
      if (process.env.REACT_APP_ENV != undefined && process.env.REACT_APP_ENV === 'PRD') {
        oDoc
          .querySelector('link[rel="manifest"]')
          .setAttribute('href', process.env.PUBLIC_URL + '/manifest.json');
      } else {
        oDoc
          .querySelector('link[rel="manifest"]')
          .setAttribute('href', process.env.PUBLIC_URL + '/manifest_dev.json');
      }
    }
  }, []);

  return (
    <Routes>
      <Route path="/order/status/:order_id" element={<OrderStatusMain />} />
      <Route path="/restaurant/voucher/:voucher_history_id" element={<RestaurantVoucher />} />
      <Route element={<LoginLayout />}>
        <Route path="/" element={<Login />} />
        <Route path="/posLogin" element={<LoadingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/loginIdForget" element={<LoginForgetMain typeForgot={'id'} />} />
        <Route path="/loginPasswordForget" element={<LoginForgetMain typeForgot={'password'} />} />
        <Route path="/loginUserJoin" element={<LoginUserJoinMain />} />
        <Route path="/loginContract" element={<LoginContract />} />

        {/* 랜딩페이지 */}
        <Route path="/landing/guide" element={<GuideLanding />} />
      </Route>

      <Route path="/" element={<ProtectedLayout />}>
        <Route path="dashboard" element={<Dashboard />} />

        {/* 매장관리 */}
        {/* <Route path="/store" element={<StoreLayout />}> */}
        <Route path="/store/info" element={<StoreInfo />} />
        <Route path="/store/delivery" element={<StoreDelivery />} />
        <Route path="/store/time" element={<StoreTime />} />
        <Route path="/store/holiday" element={<StoreHoliday />} />
        <Route path="/store/testOrder" element={<StoreTestOrder />} />
        <Route path="/store/self/testOrder" element={<SelfStoreTestOrder />} />
        {/* </Route> */}

        <Route path="/store/salemanager" element={<SalesManager />} />

        {/* 상품관리 */}
        <Route path="product/category" element={<CategoryIndex />} />
        <Route path="product/category/edit" element={<CategoryEdit />} />
        <Route path="product/product" element={<ProductIndex />} />
        <Route path="product/product/edit" element={<ProductEdit />} />
        <Route path="product/option" element={<OptionIndex />} />
        <Route path="product/option/edit" element={<OptionEdit />} />
        <Route path="product/setmenu" element={<SetMenuIndex />} />
        <Route path="product/setmenu/edit" element={<SetMenuEdit />} />
        <Route path="product/setitem" element={<SetItemIndex />} />
        <Route path="product/setitem/edit" element={<SetItemEdit />} />
        <Route path="product/inventory" element={<Inventory />} />
        <Route path="product/coupon" element={<CouponIndex />} />
        <Route path="product/coupon/edit" element={<CouponEdit />} />
        <Route path="product/timeproduct" element={<TimeProductIndex />} />
        <Route path="product/timeproduct/edit" element={<TimeProductEdit />} />

        {/* 판매 관리 */}
        <Route path="sales/analysis" element={<Analysis />} />
        <Route path="sales/calendar" element={<SalesCalendar />} />
        {/* <Route path="sales/daily" element={<SalesDaily />} /> */}
        <Route path="sales/period" element={<SalesPeriod />} />
        <Route path="sales/monthly" element={<SalesMonthly />} />
        {/* <Route path="sales/category" element={<SaleCategory />} /> */}
        {/* <Route path="sales/product" element={<SalesProduct />} /> */}
        <Route path="/sales/settle" element={<SalesSettle />} />
        <Route path="/sales/hotel" element={<SalesHotel />} />
        <Route path="/sales/status" element={<SalesStatus />} />

        {/* 광고관리 */}
        <Route path="/advertise/category" element={<AdvertiseCategory />} />
        {/* <Route path="/advertise/status" element={<AdvertiseStatus />} /> */}
        <Route path="/advertise/status" element={<AdverHotelIndex />} />
        <Route path="/advertise/upload" element={<AdvertiseUpload />} />

        {/* </Route> */}
        <Route path="ceo/info" element={<CeoInfo />} />

        <Route path="notification/list" element={<NotificationIndex />} />
        <Route path="notification/posguide" element={<PosGuide />} />
      </Route>
      <Route path="o/:order_id" element={<DeliveryManDeliveryShort />} />
      <Route path="order/delivery/:order_id/:order_seq" element={<DeliveryManDelivery />} />
      <Route path="order/complete/:order_id/:order_seq" element={<DeliveryManComplete />} />
      <Route path="order/accumulate/:order_id/:order_seq" element={<DeliveryManAccumulate />} />
      <Route path="order/register/:order_id/:order_seq" element={<DeliveryManRegister />} />
      <Route path="order/withdraw/:order_id/:order_seq" element={<DeliveryManWithdraw />} />

      <Route path="order/delivery/confirm/:hotel_id" element={<DeliveryConfirmList />} />

      <Route path="/order/cancel/:orderId/:orderSeq" element={<OrderCancel />} />
      <Route path="/order/pause/:orderId/:orderSeq" element={<OrderStop />} />
    </Routes>
  );
};

export default App;
